import { defineStore } from "pinia";
// import api from "@/plugins/axios";
// import router from "@/router";

export const useUserStore = defineStore("user",{
  state: () => ({
    user: {},
  }),
  actions: {
    setUser(user) {
        localStorage.setItem("user_data",JSON.stringify(user));
      this.user = user;
    },

    setToken(token){
        localStorage.setItem("user_token",token);
    },

    loadUser(){
        const user = JSON.parse(localStorage.getItem("user_data"));
        if(user){
            this.user = user;
        }
    },

    
  },
});

